import { render } from "./Zombie.vue?vue&type=template&id=12a83ab5&scoped=true"
import script from "./Zombie.vue?vue&type=script&lang=js"
export * from "./Zombie.vue?vue&type=script&lang=js"

import "./Zombie.vue?vue&type=style&index=0&id=12a83ab5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a83ab5"]])

export default __exports__